import { ReactNode } from 'react';

interface FormStepHeaderProps {
  title: string;
  description: string;
  step: 1 | 2 | 3;
  children?: ReactNode;
}

export function FormStepHeader({ title, description, step, children }: FormStepHeaderProps) {
  return (
    <>
      <div className="space-y-2">
        <h1 className="font-serif text-2xl font-medium">
          <span className="text-gray-400">{step}.</span> {title}
        </h1>
        <p className="text-xs text-gray-500">{description}</p>
      </div>

      <div className="flex items-center gap-6 pr-4">
        {/* Navigation */}
        {children && <div className="flex items-center gap-2">{children}</div>}

        {/* Step indicator */}
        <div className="flex gap-3">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className={`h-1.5 rounded-full transition-all duration-500 ease-in-out ${
                i === step ? 'w-5 bg-teal-400' : i < step ? 'w-1.5 bg-teal-400' : 'w-1.5 bg-gray-300'
              }`}
            />
          ))}
        </div>
      </div>
    </>
  );
}
